import { useCallback } from 'react';
import { prop } from 'ramda';

import { useConfigTag } from '@interlayer/js/app/hooks/useConfigTag';
import { useScript } from '@interlayer/js/app/hooks/useScript';
import { useRegistrationSelector } from '@interlayer/js/app/store/hooks/useRegistrationSelector';
import { CONFIG_TAG_TYPE } from '@interlayer/js/components/system/TagManager/buzz/constants';
import { TBuyaPowaConfigTagConfig } from '@interlayer/js/components/system/TagManager/buzz/types';

export const useBuyaPowaTrack = () => {
    const buyapowaUserId = useRegistrationSelector(prop('buyapowaUserId'));
    const buyaPowaConfig = useConfigTag(CONFIG_TAG_TYPE.buyaPowaConfig) as TBuyaPowaConfigTagConfig;
    const isScriptLoaded = useScript(buyapowaUserId && buyaPowaConfig?.config?.registerScriptUrl);

    return useCallback(({ userDetails: { userId = '' } = {} } = {}) => {
        if (!isScriptLoaded || !window.Buyapowa || !userId) {
            return;
        }

        const buyapowa = new window.Buyapowa({
            url: buyaPowaConfig?.config?.bpUrl, market: buyaPowaConfig?.config?.market
        });

        buyapowa.track({
            // eslint-disable-next-line camelcase
            marketing_opt_in: true,
            // eslint-disable-next-line camelcase
            order_number: userId,
            // eslint-disable-next-line camelcase
            user_id: userId,
            locale: 'en'
        });
    }, [buyaPowaConfig?.config?.bpUrl, isScriptLoaded, buyaPowaConfig?.config?.market]);
};
